// extracted by mini-css-extract-plugin
export var dietary = "RegistrationFormAiMining-module--dietary--fe893";
export var formSubmit = "RegistrationFormAiMining-module--formSubmit--41489";
export var holder = "RegistrationFormAiMining-module--holder--b08a4";
export var info = "RegistrationFormAiMining-module--info--0ca81";
export var location = "RegistrationFormAiMining-module--location--501ab";
export var main = "RegistrationFormAiMining-module--main--88530";
export var registrationForm = "RegistrationFormAiMining-module--registrationForm--3a3b2";
export var registrationFormWrapper = "RegistrationFormAiMining-module--registrationFormWrapper--6bb1c";
export var submit = "RegistrationFormAiMining-module--submit--4f985";
export var submitRegistrationForm = "RegistrationFormAiMining-module--submitRegistrationForm--3a4f5";
export var wrapper = "RegistrationFormAiMining-module--wrapper--52509";